button.arrow-button
  .line
    span
  .icon
    <svg viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0H0L4 4L8 0Z" fill="white"/>
    </svg>

